// @core/api/endpoints/resource/link_resources.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LinkResourcesRequest,
  ResourceLinkResponse,
} from '../../../types/resource';

const BASE_PATH = '/resource';

/**
 * Link two resources
 * Creates a directed link between a source and target resource with a specified relation type. Publishes a resource.linked Kafka event.
 */
export async function LinkResources(
  data: LinkResourcesRequest,
  options?: RequestOptions
): Promise<ResourceLinkResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources/links`;
  const requestOptions = options;
  return client.post<ResourceLinkResponse>(requestPath, data, requestOptions);
}
